module.exports = __webpack_public_path__ + "static/img/微信图片_20220709152241.1a86ffa1.jpg";